import styled from 'styled-components';
import { SIZE } from '@app/src/ui';

interface Props {
  isShow?: boolean;
}

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  height: 50px;
  font-size: 9.5px;
  display: ${(props: Props) => props.isShow
    ? 'flex'
    : 'none'};

  a {
    padding: 0 6px;
  }

  nav {
    width: 100%;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    display: none;
  }
`;

const MAIN = 'HeaderResponsive';
Wrapper.displayName = `${MAIN}/Wrapper`;
